<div class='logo-wrap height-100p width-100p'>
  <img [routerLink]='link' data-qa='approval-app-canto-logo' *ngIf='logo && logo.src' [src]='logo.src'
       [ngClass]="{'cursor-pointer': link}"
       class='logo' alt='canto-logo'>
</div>
